import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCombosControllerModule } from './controllers/ProgramsCombosController';
import { ProgramsCombosCreateView } from './create/create';
import { ProgramsCombosListView } from './list/list';

export const ProgramsCombosView = angular
  .module('acme.view.application.programs.combos', [
    uiRouter,
    'ui.bootstrap',
    ProgramsCombosControllerModule,
    ProgramsCombosListView,
    ProgramsCombosCreateView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.combos',
      url: '/combos',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'ProgramsCombosController',
          templateUrl: 'views/application/views/programs/combos/combos.tpl.html',
        },
      },
      data: {
        pageTitle: 'Combos',
      },
    });
  }).name;
